/* istanbul ignore file: this file does not contain any logic, only factory calls */
import { createRequestFactory, BaseOptions } from "@devowl-wp/utils"; // Only needed once per `window`

var FACTORY_MEMO;

function get() {
  return FACTORY_MEMO ? FACTORY_MEMO : FACTORY_MEMO = createRequestFactory(window[BaseOptions.getPureSlug(process.env, true)]);
}

var urlBuilder = function urlBuilder() {
  var _get;

  return (_get = get()).urlBuilder.apply(_get, arguments);
};

var request = function request() {
  var _get2;

  return (_get2 = get()).request.apply(_get2, arguments);
};

export { urlBuilder, request };